import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<PropTypes.InferProps<typeof propTypes>>}
 */
const CarouselItemProgrammeCarouselItem = ({
    calendarItemType = null,
    carouselItemIndex = null,
    description = null,
    image = null,
    listingImage = null,
    mobileFullWidth = false,
    title = null,
    url = null
}) => {
    return (
        <>
            {carouselItemIndex === 0 && (
                <div className='hidden md:block md:w-1/6 layout-grid-col-padding'/>
            )}

            <div className={`expand-interaction px-10 md:px-15${carouselItemIndex === 0 ? ' w-12/12 md:w-5/6' : ' w-12/12'}`}>
                <a
                    className='block'
                    href={url}>
                    {calendarItemType && (
                        <p
                            className='type-style-4'
                            style={{ lineHeight: 1 }}>
                            {calendarItemType}
                        </p>
                    )}

                    {(image || listingImage) && (
                        <img
                            alt={listingImage?.alt || image?.alt}
                            className={mobileFullWidth ? 'w-screen md:w-full max-w-none md:max-w-full aspect-square md:aspect-auto -ml-20 sm:-ml-40 md:ml-0 mt-20 md:mt-30 object-cover object-center' : 'w-full mt-20 md:mt-30'}
                            height={listingImage?.height || image?.height}
                            loading='lazy'
                            src={listingImage?.px2 || image?.px2}
                            width={listingImage?.width || image?.width} />
                    )}

                    {title && (
                        <p
                            className='type-style-3 mt-30'
                            style={{ lineHeight: 1 }}>
                            {title}
                        </p>
                    )}

                    {description && (
                        <div
                            className='type-style-4 mt-20'
                            dangerouslySetInnerHTML={{ __html: description }}/>
                    )}
                </a>
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    calendarItemType: PropTypes.string,
    carouselItemIndex: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    image: PropTypes.object.isRequired,
    listingImage: PropTypes.object,
    mobileFullWidth: PropTypes.bool,
    title: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
};

CarouselItemProgrammeCarouselItem.propTypes = propTypes;

export default CarouselItemProgrammeCarouselItem;
